// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3zCSY","header":"MessagesList_header__3cNDZ","chat":"MessagesList_chat__3x0jX"};